<style scoped lang="scss">
  .el-menu {
    border: none;
  }
  .menu-warp {
    height: 100%;
  }
  .menu-scroll {
    overflow: hidden;
    width: 125px;
  }
  .menu {
    height: 100%;
    padding-top: 100px;
    padding-bottom: 80px;
    box-sizing: border-box;
    overflow-y: overlay;
    margin-right: -15px;
    background: $auxiliary_hue;
    .el-menu-item {
      height: 45px;
      line-height: 45px;
      &.is-active {
        background: #fff !important;
        i {
          color: $auxiliary_hue;
        }
      }
      i {
        display: inline-block;
        width: 24px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        font-size: 14px;
        color: $dominant_hue;
      }
    }
  }
  .sub-menu {
    height: 100%;
    overflow-y: overlay;
    margin-right: -15px;
    padding: 10px 0;
    .el-menu-item {
      height: 38px;
      line-height: 38px;
      &:hover {
        background-color: rgba(255,255,255,0.5) !important;
      }
      &.is-active {
        background: #fff !important;
      }
    }
  }
  .el-menu-item-group {
    padding-bottom: 20px;
  }
  .menu-group {
    position: relative;
    &::after {
      position: absolute;
      left: 20px;
      right: 20px;
      top: 0;
      height: 1px;
      background: #f8f8f8;
      content: "";
    }
  }
  .sub-menu {
    .el-menu-item-group__title {
      margin-top: 10px;
    }
    .menu-group:first-child::after {
      content: none;
    }
  }
</style>

<style lang="scss">
  .sub-menu {
    .el-menu-item-group__title {
      padding-top: 20px;
    }
    .el-menu-item:hover {
      background: #f8f8f8;
    }
  }
</style>

<template>
  <el-container>
    <!--左侧菜单开始-->
    <el-aside class="aside" :class="{'no-sub': $route.meta && $route.meta.hideMenu}" v-if="isShowAside">
      <div class="menu-warp view-flex">
        <div class="menu-scroll">
          <div class="menu">
            <router-link class="brand" :to="{path: path_prefixes ? '/' + path_prefixes : '/'}">
              <img :src="brandIco" alt="">
            </router-link>
            <el-menu :default-active="$route.matched[0].path ? $route.matched[0].path : $route.matched[1].path" :background-color="theme.$auxiliary_hue" text-color="#fff" :active-text-color="theme.$auxiliary_hue" @select="handleChange">
              <el-menu-item v-for="(item, index) in $router.options.routes" :key="index" v-if="!item.hidden" :index="item.path" @click="toRoute(item.path)" >
                <i class="iconfont" :class="'iconfont icon-' + item.iconCls"></i> {{item.name}}
              </el-menu-item>
            </el-menu>
          </div>
        </div>
        <template v-if="$route.meta && !$route.meta.hideMenu">
          <div class="menu-scroll" v-for="(item,index) in $router.options.routes" v-if="isCurrentSubmenu(item.path)">
            <el-menu :default-active="$route.matched.length > 3 ? $route.matched[$route.matched.length-2].path : $route.path" class="sub-menu" :background-color="theme.$submenu_bg" :text-color="theme.$submenu_text" :active-text-color="theme.$submenu_act_text" router>
              <template v-for="(child, index) in item.children" v-if="!child.hidden">
                <el-menu-item-group v-if="child.isLeaf" class="menu-group">
                  <template slot="title">{{child.name}}</template>
                  <template v-for="(sub, index) in child.children">
                    <el-menu-item :key="sub.path" :index="sub.path" v-if="!sub.hidden">{{sub.name}}</el-menu-item>
                  </template>
                </el-menu-item-group>
                <div v-else class="menu-group">
                  <el-menu-item :index="child.path">{{child.name}}</el-menu-item>
                </div>
              </template>
            </el-menu>
          </div>
        </template>
      </div>
    </el-aside>
    <el-button @click="showAside" icon="el-icon-menu" size="mini" type="primary" style="position: absolute; top: 0; left: 0; z-index: 9999; padding: 3px 7px; font-size: 16px;"></el-button>
    <el-container>
      <el-header class="header" height="50px">
        <div class="view-flex-item"></div>
        <div class="view-flex view-flex-middle">
          <div class="icon-nav">
            <el-badge v-if="this.$store.getters.login_type == 'distributor'">
              <i class="iconfont icon-store-alt"  @click="handleClickSelectShop"></i>
            </el-badge>
            <!--el-badge v-else>
              <a href="/shopadmin/login" target="_blank"><i class="iconfont icon-store-alt"></i></a>
            </el-badge-->
          </div>
          <div class="icon-nav" v-if="false">
            <el-badge is-dot>
              <i class="iconfont icon-bell"></i>
            </el-badge>
          </div>
          <div class="user-setting">
            <el-popover
              placement="bottom"
              trigger="hover"
              popper-class="logout-popper"
              v-model="visible2">
              <div class="content-padded dom-link" @click="handleUserInfo">
                <div class="view-flex view-flex-middle">
                  <img v-if="avatar" class="user-avatar" :src="avatar" />
                  <i v-else class="user-avatar iconfont icon-user-circle1"></i>
                  <div>
                    <div>{{nick_name || name}}</div>
                    <small class="muted">基础信息</small>
                  </div>
                </div>
              </div>
              <div class="section-footer with-border small dom-link muted" @click="logout">退出登录</div>
              <img slot="reference" v-if="avatar" class="user-avatar" :src="avatar" />
              <i v-else slot="reference" class="iconfont icon-user-circle1"></i>
            </el-popover>
          </div>
        </div>
      </el-header>
      <el-main>
        <section id="container" class="content-container">
          <el-col :span="24" class="content-wrapper">
            <transition name="fade" mode="out-in">
              <router-view></router-view>
            </transition>
          </el-col>
        </section>
      </el-main>
    </el-container>
  </el-container>
</template>
<script>
  import { getBrandLogo } from '@/api/common'
  import { mapGetters } from 'vuex'
  import store from '../store'
  export default {
    data () {
      return {
        screenwidth: document.body.clientWidth,
        socket: '',
        interval: '',
        isShowAside: true,
        findMenu: false,
        menusList: [],
        homeIndex: '',
        activeIndex: '',
        brandIco: '',
        visible2: false,
        isCurrentSubmenu: function (path) {
          const homePath = this.path_prefixes ? `/${this.path_prefixes}` : '/'
          if (path.indexOf('/shopadmin') !== -1) {
            return path.split('/')[2] == this.$route.path.split('/')[2]
          }

          if (path !== homePath) {
            if (this.path_prefixes) {
              return path.split('/')[2] == this.$route.path.split('/')[2]
            } else {
              return path.split('/')[1] == this.$route.path.split('/')[1]
            }
          }
        }
      }
    },
    computed: {
      ...mapGetters([
        'name',
        'nick_name',
        'avatar',
        'wxapp_id',
        'template_name'
      ])
    },
    methods: {
      showAside() {
        this.isShowAside = !this.isShowAside
      },
      handleClickSelectShop(){
        this.$router.push({path: this.path_prefixes ? `/${this.path_prefixes}/shopadmin/shoplist` : '/shopadmin/shoplist'})
      },
      handleChange (key) {
        this.activeIndex = key
      },
      handleUserInfo () {
        this.$router.push({
          path: this.matchInternalRoute('admininfo')
        })
      },
      toRoute (path) {
        this.$router.push({
          path: path
        })
      },
      logout: function () {
        this.$store.dispatch('unsetToken').then(() => {
          console.log(this.socket)
          if (this.socket) {
            this.socket.close()
          }
          window.clearInterval(this.interval)
          this.$router.push({ path: this.path_prefixes ? `/${this.path_prefixes}/login` : `/login` })
        })
      },
      webSocketInit () {
        let token = this.$store.getters.token
        if (typeof(WebSocket) == 'undefined') {
          this.$notify({
            title: '提示',
            message: '当前浏览器暂不支持实时消息提醒，请使用谷歌浏览器！',
            type: 'warning',
            duration: 0
          });
        } else {
          let socketUrl = process.env.WEBSOCKET_URL + '?token=' + token + '&sockettype=merchantordertipsmsg'
          this.socket = new WebSocket(socketUrl)
          this.socket.onopen = this.open
          this.socket.onmessage = this.getMessage
          this.socket.onerror = this.error
          this.socket.onclose = this.close
        }
      },
      open (e) {
        console.log('打开 WebSocket 连接')
      },
      error (e) {
        console.log('WebSocket 连接失败：', e)
      },
      getMessage (ret) {
        if (ret.data == 'pong') {
          return
        }
        let data = JSON.parse(ret.data)
        console.log(data)
        let audio = ''
        if (data.message_type == 'orderpayedtips') {
          audio = new Audio('../../static/audio/payed.mp3')
          audio.play()
        } else if (data.message_type == 'orderrefundtips') {
          audio = new Audio('../../static/audio/refund.mp3')
          audio.play()
        } else if (data.message_type == 'orderaftersaletips') {
          audio = new Audio('../../static/audio/aftersale.mp3')
          audio.play()
        }
        this.$notify({
          title: data.title,
          message: data.message,
          type: data.status,
          duration: 0,
          onClick: () => {
            console.log('点击触发事件')
            console.log(data)
          }
        });
      },
      send (data) {
        this.socket.send(data)
      },
      close (e) {
        console.log('断开 WebSocket 连接')
      },
      ping () {
        const that = this
        let times = 0
        this.interval = window.setInterval(function () {
          if (that.socket.readyState == 1) {
            that.send('ping')
          }
          if (that.socket.readyState == 3) {
            times += 1
            if (times >= 10) {
              that.$notify({
                title: '提示',
                message: '系统连接已断开，请稍后刷新重试~',
                type: 'warning',
                duration: 0
              });
              window.clearInterval(that.interval)
            }
            that.reconnect()
          }
        }, 5000)
      },
      reconnect () {
        this.webSocketInit()
      }
    },
    mounted () {
      window.onresize = () => {
        return this.screenwidth = document.body.clientWidth
      }
      // 如果屏幕尺寸小于 600，则隐藏侧边栏
      if (this.screenwidth < 600) {
        this.isShowAside = false
      } else {
        this.isShowAside = true
      }
      // this.webSocketInit()
      // this.ping()
      getBrandLogo().then(res => {
        if (res.data.data.logo) {
          this.brandIco = res.data.data.logo
        } else {
          this.brandIco = require('../../static/img/' + this.companyBrandImg + '/logo_ico.svg')
        }
      }).catch(() => {
        this.brandIco = require('../../static/img/' + this.companyBrandImg + '/logo_ico.svg')
      })
      this.activeIndex = this.$route.meta.sn
    },
    watch: {
      screenwidth: {
        immediate: true,
        handler: function (val) {
          console.log(val);
          // 如果屏幕尺寸小于 600，则隐藏侧边栏
          if (val < 600) {
            this.isShowAside = false
          } else {
            this.isShowAside = true
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// layout.vue?29f7b237